import {useState} from 'react';
import {gql, useLazyQuery} from '@apollo/client';

type Connection = {
	serverUrl: string;
	roomName: string;
	participantName: string;
	participantToken: string;
};

interface Vars {
	attributes: string
}

interface Result {
	auth: {
		user: {
			id: string
			webrtc: {
				server: string
				token: string
				room: string
			}
		}
	}
}

const getToken = gql`
query ($attributes: String) {
	auth {
		id
		user {
			id
			webrtc {
				server
				token(attributes: $attributes)
				room
			}
		}
	}
}`;

export const useConnection = (report: string) => {
	const [connection, setConnection] = useState<Connection | null>(null);
	const [load] = useLazyQuery<Result, Vars>(getToken, {
		variables: {
			attributes: JSON.stringify({
				report,
			}),
		}
	});

	return {
		connection,
		onConnect: async () => {
			const results = await load();
			if (results.data) {
				setConnection({
					serverUrl: results.data.auth.user.webrtc.server,
					roomName: results.data.auth.user.webrtc.room,
					participantName: results.data.auth.user.id,
					participantToken: results.data.auth.user.webrtc.token,
				});
			}
		},
	};
};
